export default __webpack_public_path__ + "static/media/MF.2d431137.svg";